import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { ButtonIcon, FormHeader, Tag } from "..";
import { getLanguage } from "../../utils/environment";
import moment from "moment";
import { motion } from "motion/react";

const lan = getLanguage();

const Index = ({ data, onChange, onClick, isBorder, item }) => {
  let inputElement = null;

  inputElement = (
    <>
      <motion.div
        whileHover={{ x: 1 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <div className={`rjcmw-body-wrapper`} onClick={onClick}>
          {/* {data.isTrendingNo && (
            <>
              <div className={"tncmw__trending-no"}>{data.trendingNo}</div>
            </>
          )} */}
          {/* {data.created_at && data.isDate && (
            <>
              <div className={"tncmw__news-date"}>
                <span className={"tncmw__nd-day"}>
                  {moment(data.created_at).format("DD")}
                </span>
                <span className={"tncmw__nd-month"}>
                  {moment(data.created_at).format("MMM")}
                </span>
              </div>
            </>
          )} */}
          <div className="d-flex flex-row ">
            <img src={data?.img_url} alt="job-img" className={"rjcmw__img"} />

            {data?.isArrow && (
              //  <motion.div
              //   className="tncmw__action"
              //   whileHover={{ scale: 1.2, rotate: 5 }}
              //   whileTap={{ scale: 0.95 }}
              //   transition={{ type: "spring", stiffness: 300 }}
              // >
              <div className="rjcmw-arrow-button-mobile ">
                <ButtonIcon
                  data={{
                    iconName: "h-wrrow-right",
                    size: "xl",
                    type: "light",
                  }}
                />
              </div>
            )}
          </div>
          <div style={{ width: "100%" }}>
            <div className={" rjcmw-details-wrapper "}>
              <div className={"d-flex flex-column"}>
                <div>
                  <FormHeader
                    data={{
                      formHeader: data?.titleEn,
                      lan: "en",
                      size: "xs xx",
                    }}
                  />
                  <FormHeader
                    data={{
                      formHeader: data?.titleSi,
                      lan: "si",
                      size: "xs",
                    }}
                  />
                </div>
                <div className="d-flex flex-row align-items-center rjcmw_view_box">
                  <Tag
                    data={{
                      isIcon: false,
                      type: "gray",
                      tagName:
                        "Closing date : " +
                        moment(data?.closingDate).format("DD-MMM-YYYY"),
                    }}
                  />
                  <div className="d-flex p-2">
                    <Tag
                      data={{
                        isIcon: false,
                        type: "gray",
                        tagName: data?.organization,
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* <img
                src={data?.img_url}
                alt="news-img"
                className={"tncmw__img"}
              /> */}

              {data?.isArrow && (
                //  <motion.div
                //   className="tncmw__action"
                //   whileHover={{ scale: 1.2, rotate: 5 }}
                //   whileTap={{ scale: 0.95 }}
                //   transition={{ type: "spring", stiffness: 300 }}
                // >
                <div className="rjcmw-arrow-button">
                  <ButtonIcon
                    data={{
                      iconName: "h-wrrow-right",
                      size: "xl",
                      type: "light",
                    }}
                  />
                </div>
              )}
            </div>

            {data.isBorder && (
              <>
                <div className={"rjcmw__border"}></div>
              </>
            )}
          </div>
        </div>
      </motion.div>
    </>
  );

  return (
    <>
      <div
        className={`related-jobs-card-main-wrapper ${data.type}  ${data.mainLayerStyles}`}
      >
        <>{inputElement}</>
      </div>
    </>
  );
};

export default Index;
